module.exports = __webpack_public_path__ + "img/seoul284.cbaf16f6.png";